export default __webpack_public_path__ + "static/media/NN.16e3531b.png";